import PageBanner from "../../../../src/components/PageBanner";
import Sponsors from "../../../../src/components/Sponsors";
import * as React from 'react';
export default {
  PageBanner,
  Sponsors,
  React
};